import config from "../../config/config";
import * as mocks from "./modules.mocks";
import { CreateModuleInputs, Module, UpdateModuleInputs } from "./modules.interfaces";
import * as api from "./modules.api";

export const getModules = async (): Promise<Module[]> => {
    return await (config.useRealApi ? api.apiGetModules() : mocks.getModules());
};

export const getModule = async (id: string): Promise<Module> => {
    return await (config.useRealApi ? api.apiGetModule(id) : mocks.getModule(id));
};

export const createModule = async (data: Omit<CreateModuleInputs, 'packageId'>): Promise<string> => {
    return await (config.useRealApi ? api.apiCreateModule(data) : mocks.createModule(data));
};

export const updateModule = async (id: string, data: UpdateModuleInputs): Promise<void> => {
    return await (config.useRealApi ? api.apiUpdateModule(id, data) : mocks.updateModule(id, data));
};

export const deleteModule = async (id: string): Promise<void> => {
    return await (config.useRealApi ? api.apiDeleteModule(id) : mocks.deleteModule(id));
};
